// libraries.
import { Button } from 'react-bootstrap';
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// types.
import { ActionTaskEnum } from '../../DocumentsAuditDashboard/components/DocumentsTable/TaskAction';

// hooks.
import { getCountry } from '@domains/user/store/slices/user-slice/user-slice';
import { useUpdateTaskStatusMutation } from '@domains/documents-review/store/api-slices/update-task-status.endpoints';
import {
  clearSelectedTasks,
  getSelectedTasks,
} from '@domains/documents-review/store/slices/document-review-slice';
import { ReassignModal } from './ReassignModal';
import { DropdownAgents } from './DropdownAgents';
import { useHandleReassignTasks } from '../utils';

// styles.
import { IconReassignWhite, IconWarning } from '@assets/icons';
import { WrapperReassignButton } from './styles';

interface ReassignProps {
  refetch: () => void;
}

export const ReassignSelectedTasks = ({ refetch }: ReassignProps) => {
  const dispatch = useDispatch();

  const [showModal, setShowModal] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState<string>('');
  const selectedIds = useSelector(getSelectedTasks);
  const selectedIdsAsString = selectedIds?.join(',');

  const country = useSelector(getCountry) as 'MX' | 'CO';

  const [mutateAssignTask, { isLoading, isError, isSuccess, reset }] =
    useUpdateTaskStatusMutation();

  const handleClick = () => setShowModal(true);
  const handleClose = () => {
    dispatch(clearSelectedTasks());
    setShowModal(false);
  };

  const handleReassign = () => {
    if (selectedAgent) {
      const reasignTasks = {
        id: selectedIdsAsString,
        agent: selectedAgent,
      };
      mutateAssignTask({
        agent: reasignTasks.agent,
        reassign_ids: reasignTasks.id,
        country: country,
        status: ActionTaskEnum.PENDING,
      });
    }
  };

  const clearState = useCallback(() => {
    dispatch(clearSelectedTasks());
    setSelectedAgent('');
    reset();
    refetch();
  }, [dispatch, reset, refetch]);

  useHandleReassignTasks(isError, isSuccess, setShowModal, clearState);

  if (selectedIds?.length < 1) return null;

  return (
    <WrapperReassignButton>
      <Button className="d-flex align-items-center gap-2" onClick={handleClick}>
        <IconReassignWhite />
        Reasignar selección
      </Button>
      <ReassignModal
        icon={<IconWarning />}
        show={showModal}
        handleClose={handleClose}
        handleSave={handleReassign}
        title="Cambiar de agente"
        subtitle="Selecciona el agente"
        description=""
        disabled={isLoading}
      >
        <DropdownAgents
          onSelectAgent={setSelectedAgent}
          value={selectedAgent}
        />
      </ReassignModal>
    </WrapperReassignButton>
  );
};
